import { inject } from 'aurelia-framework';
import { EventAggregator } from 'aurelia-event-aggregator';
import { UnitOfMeasurementService } from 'pages/system-fields/unit-of-measurements/service';
import { DialogService } from 'aurelia-dialog';
import { formatTableLink, creatTableButton } from 'resources/utility';
import toastr from 'toastr';

@inject(UnitOfMeasurementService, DialogService, EventAggregator)
export class Statuses {
    constructor(unitOfMeasurementService, dialogService, ea) {
        this.ea = ea;
        this.unitOfMeasurementService = unitOfMeasurementService;
        this.dialogService = dialogService;

        this.columns = [
            { dataField: 'name', sortOrder: 'asc', cellTemplate: (container, options) => formatTableLink({ container, containerOptions: options, callback: this.edit }) },
            { caption: 'Actions', cellTemplate: (container, options) => creatTableButton({ container, containerOptions: options, style: 'danger', label: 'Delete', action: this.delete }), allowExporting: false }
        ];

        this.subscription = this.ea.subscribe('unit-of-measurements:updated', () => {
            this.grid.refresh();
        });
    }

    deactivate () {
        this.subscription.dispose();
    }

    delete = (unitOfMeasurement) => {
        this.dialogService.open({ viewModel: PLATFORM.moduleName('resources/elements/modals/confirm/index') }).whenClosed(async response => {
            if (!response.wasCancelled) {
                await this.unitOfMeasurementService.delete(unitOfMeasurement.id);
                this.grid.refresh();
                toastr.success('Status was deleted!');
            }
        });
    };

    add() {
        this.dialogService.open({ viewModel: this.unitOfMeasurementService.editor });
    }

    edit = (data) => {
        this.dialogService.open({ viewModel: this.unitOfMeasurementService.editor, model: { id: data.id } });
    };
}